module.exports = __webpack_public_path__ + "img/keder_opalgruen_ral6026.e16a599f.jpg";